import { DownloadOutlined } from '@mui/icons-material'
import { IconButton, Tooltip, Typography, useTheme } from '@mui/material'
import { DeleteButtonWithConfirmation } from 'components/Common/Button/DeleteButtonWithConfirmation'
import { useDateString } from 'model/DateString'
import { useTranslation } from 'react-i18next'
import { AttachmentDetailsProps } from './AttachmentDetailsProps'

export const AttachmentCards = (props: AttachmentDetailsProps) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const dateString = useDateString()

  return (
    <ul
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        // display: 'flex',
        // flexWrap: 'wrap',
        justifyContent: 'center',
        gap: theme.spacing(2),
        padding: theme.spacing(2),
      }}
    >
      {props.filteredAttachments?.map((attachment) => (
        <li
          key={attachment.id}
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '300px',
            border: `1px solid ${theme.palette.divider}`,
            borderRadius: theme.shape.borderRadius,
            position: 'relative',
            justifyContent: 'space-between',
          }}
        >
          {/* {attachment.originalFileName.toLowerCase().endsWith('.pdf') ? (
            <div
              style={{
                position: 'relative',
                minWidth: '32px',
                width: '100%',
                height: '200px',
                overflow: 'hidden',
                textAlign: 'center',
              }}
            >
              <AttachmentPreview
                bomItemPointer={props.bomItemPointer}
                fileName={attachment.originalFileName}
                pdfViewModel={props.pdfViewModel}
                attachmentId={attachment.id}
                loading={props.loading}
                setPdfViewModel={props.setPdfViewModel}
                thumbnailFileName={attachment.thumbnail}
                onClick={() => {
                  props.onOpenDrawings(attachment.id)
                }}
              />
            </div>
          ) : (
            <div />
          )} */}
          <div
            style={{
              textAlign: 'center',
              padding: theme.spacing(1),
            }}
          >
            <Typography variant="body2" fontWeight={'bold'}>
              {attachment.originalFileName}
            </Typography>
            <Typography variant="caption" noWrap>
              {dateString(attachment.dateCreated)}
            </Typography>
            {/* {props.pdfViewModel?.pages?.filter(
              (x) => x.pageId === attachment.id,
            )?.length ? (
              <Typography variant="caption" component="p" color="textSecondary">
                {t('project:attachment-pages', {
                  count: props.pdfViewModel.pages.filter(
                    (x) => x.attachmentId === attachment.id,
                  ).length,
                  defaultValue: '{{count}} pages',
                })}
              </Typography>
            ) : null} */}
          </div>
          <div
            style={{
              display: 'flex',
              gap: theme.spacing(1),
              justifyContent: 'flex-end',
            }}
          >
            <DeleteButtonWithConfirmation
              title={t('project:delete-attachment', 'delete attachment')}
              onDelete={() => props.onDelete(attachment)}
              buttonType="icon"
            />
            <Tooltip
              title={t('project:download-attachment', 'download attachment')}
              arrow
            >
              <IconButton
                onClick={() => {
                  props.onDownload(attachment)
                }}
                size="small"
                color="primary"
              >
                <DownloadOutlined />
              </IconButton>
            </Tooltip>
          </div>
        </li>
      ))}
    </ul>
  )
}
